document.addEventListener('DOMContentLoaded', function () {
  try {
    var raw = sessionStorage.getItem('scroll-position');
    if (raw) {
      var data = JSON.parse(raw);
      // Kun genskab scroll, hvis vi er på SAMME path som da vi gemte
      if (data && data.path === window.location.pathname) {
        window.scrollTo(0, data.y || 0);
      }
      sessionStorage.removeItem('scroll-position');
    }
  } catch (e) {
    // fail silent
  }

  window.addEventListener('beforeunload', function () {
    try {
      var data = {
        path: window.location.pathname,
        y: window.scrollY || 0
      };
      sessionStorage.setItem('scroll-position', JSON.stringify(data));
    } catch (e) {
      // ignore
    }
  });
});
